// extracted by mini-css-extract-plugin
export default {"chip-list":"chip-list--svMD3"};